export default "__VITE_ASSET__CQnWDxFw__"